import { z } from 'zod';
import { optionalMongoObjectId } from './object-id-helpers.js';

export const ProblemSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    title: z.string().min(1, 'form.validation.nameRequired'),
    description: z.string().optional().or(z.literal('')),
    status: z.enum(['open', 'investigating', 'resolved', 'closed']).default('open'),
    priority: z.enum(['low', 'medium', 'high', 'critical']).default('medium'),
    /** @deprecated use relatedTicket */
    relatedTicketId: z.string().optional().or(z.literal('')),
    relatedTicket: optionalMongoObjectId,
    isKnownError: z.boolean().optional(),
    knownErrorPublishedAt: z.union([z.string(), z.date()]).optional().nullable(),
    serviceCatalogItem: optionalMongoObjectId,
    rootCause: z.string().optional().or(z.literal('')),
    workaround: z.string().optional().or(z.literal('')),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateProblemSchema = ProblemSchema.omit({ id: true });
export const UpdateProblemSchema = CreateProblemSchema.partial();
